/**
 * SOLID Review
 * S — Strong. One use case: watch the streams of the table as it stands — its room's and its round's.
 * O — Strong. Which streams a target opens is the watch's.
 * L — Strong. Implements its use-case role exactly.
 * I — Strong. `execute`.
 * D — Strong. The state and watch ports, injected.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { ICommandNothing } from '../../domain/ports/schemas/TableMoves';
import type { IPayloadWatchTarget } from '../ports/contracts';
import type { TPortOutcome } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import type { IConfigDepTable } from './IConfigDepTable';

/** Watch the table as it stands (FE1's watchTable) — idempotent downstream: StrictMode runs the effect twice. */
export class WatchTableUseCase implements IUseCase<ICommandNothing, TPortOutcome> {
  constructor(private readonly deps: IConfigDepTable) {}

  async execute(ctx: IContextRequest, _command: ICommandNothing): Promise<TPortOutcome> {
    const loaded = await this.deps.state.snapshot(ctx);
    if (!loaded.success) return loaded;
    const target: IPayloadWatchTarget = { roomId: loaded.value.table.room?.roomId ?? null, roundId: loaded.value.table.activeRoundId };
    return this.deps.watch.watch(ctx, target);
  }
}
